import Select from 'react-select'
import styled from 'styled-components'

import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const DROPDOWN_PREFIX = 'StyledNavDropdown'

export const StyledBreadcrumb = styled(Select)<{ value: string }>`
  animation: ${theme.animations.fadeIn} 0.3s ease-out;
  ${Font14};
  min-width: 160px;
  border-color: ${theme.colors.pelicanGrey};
  &:last-child {
    border-color: ${(p) => !p.value && theme.colors.lightGrey};
  }

  .${DROPDOWN_PREFIX}__control {
    border-color: inherit;
    border-radius: 8px;
    min-height: 40px;
    outline: none;
    box-shadow: none;
    :hover {
      border-color: ${theme.colors.horizonOrange};
    }
  }

  .${DROPDOWN_PREFIX}__control--menu-is-open {
    border-color: ${theme.colors.horizonOrange};
  }

  .${DROPDOWN_PREFIX}__indicator-separator {
    display: none;
  }

  .${DROPDOWN_PREFIX}__dropdown-indicator {
    color: ${theme.colors.duneWarmGrey};
  }

  .${DROPDOWN_PREFIX}__menu {
    color: ${theme.colors.duneWarmGrey};

    .${DROPDOWN_PREFIX}__option {
      color: ${theme.colors.otterWarmBlack};
      word-break: break-all;
      cursor: pointer;

      :hover {
        color: ${theme.colors.horizonOrange};
      }
    }

    .${DROPDOWN_PREFIX}__option--is-selected,
      .${DROPDOWN_PREFIX}__option--is-focused {
      background-color: transparent;
    }
  }

  & + & {
    margin-top: 16px;

    @media ${theme.devices.desktop} {
      :before {
        content: '/';
        position: absolute;
        top: 12px;
        left: -22px;
        font-weight: 600;
      }

      margin: 0 0 0 40px;
    }
  }
` as typeof Select
